import type { AdvertisingPartnerType } from '$houdini';
import type { PartnerBoxMapContent } from '$lib/components/advertising/partners/types';
import { writable } from 'svelte/store';

interface PartnerBoxmapContext {
	type: typeof AdvertisingPartnerType.BOOKING;
	context: 'itinerary_search' | 'itinerary_result_layout' | 'map_result';
}

export type PartnerBoxmapInfo = PartnerBoxMapContent | PartnerBoxmapContext;

export function isPartnerBoxmapContext(info: PartnerBoxmapInfo): info is PartnerBoxmapContext {
	return 'context' in info;
}

export function createPartnerBoxmapsStore(initialBoxmaps: PartnerBoxmapInfo[] = []) {
	const boxmapsForItineraryStore = writable<PartnerBoxmapInfo[]>(initialBoxmaps);

	return boxmapsForItineraryStore;
}
